import * as React from "react";

function Done(props) {
  return (
    <svg width="1em" height="1em" viewBox="0 0 68 68" fill="none" {...props}>
      <circle cx={34} cy={34} r={34} fill={props.color||"#076698"} />
      <path
        d="M19.234 33.66l9.617 9.617 19.235-19.234"
        stroke="#fff"
        strokeWidth={5}
        strokeLinecap="round"
      />
    </svg>
  );
}

export default Done;
